module.exports = __webpack_public_path__ + "static/img/product.d4600d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product.png
// module id = aBmt
// module chunks = 0